import { endpoints } from "../../../../configs/Settings";
import { HTTPResponseStatus } from "../../../../utils/enum";
import { useAuth } from "../../../../utils/useAuth";
import { useAxios } from "../../../../utils/useAxios";

/**
 * PUT individual — EHRPoster não aceita PUT via Bundle transaction (400).
 * Usado na edição de MedicationRequest já existente.
 */
export async function PutMedicationRequest(objData: any, id: string) {
  const url = `${endpoints.EHRPOSTER}/MedicationRequest/${id}`;

  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .put(url, objData, { headers, timeout: 20000 })
    .then((res) => {
      if (
        res.status !== HTTPResponseStatus.Created &&
        res.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PutMedicationRequest: ${res.status}`);
      }
      return res.data;
    })
    .catch((error) => {
      console.error("PutMedicationRequest ", error);
      throw new Error();
    });

  if (response) return response;
}
